import Loader from '@/components/ui/Loader';
import { useGetDistributorEditableCircuit } from '@/hooks/useCircuits';
import { useParams } from 'react-router';
import { CircuitDetails } from './CircuitDetailsPage';

const EditableCircuitDetailsPage = () => {
  const { editableCircuitId = '' } = useParams();
  const {
    data: editableCircuit,
    isLoading,
    isSuccess,
  } = useGetDistributorEditableCircuit(editableCircuitId);

  return isLoading ? (
    <Loader />
  ) : (
    isSuccess && (
      <CircuitDetails
        circuitData={editableCircuit}
        canEditCircuit
        editableCircuitId={editableCircuitId}
        canCreateEditableCircuitFromCircuit={false}
        key={editableCircuitId}
      />
    )
  );
};

export default EditableCircuitDetailsPage;
